import { createAsyncActions } from "~/utils/store";

export const LOAD_DEFAULTERS = createAsyncActions("@@REPORTS/LOAD_DEFAULTERS");

export const loadDefaulters = (params) => ({
  type: LOAD_DEFAULTERS.INIT,
  payload: {
    request: {
      method: "GET",
      url: "/reports/defaulters",
      ...params,
    },
    showLoading: false,
  },
});

export const LOAD_PARTNERS_REPORT = createAsyncActions("@@REPORTS/LOAD_PARTNERS_REPORT");

export const loadPartnersReport = (params) => ({
  type: LOAD_PARTNERS_REPORT.INIT,
  payload: {
    request: {
      method: "GET",
      url: "/reports/partners",
      ...params,
    },
    showLoading: false,
  },
});